import React, { useEffect } from 'react';
import { IdsButton } from '@investec/ids-web-react';
import { useUnifiedAnalytics } from '../../contexts/AnalyticsWrapper';

import './isaTransferProviderIntro.scss';

interface IsaTransferProviderIntroStepProps {
    onBack: () => void;
    onContinue: () => void;
}

const IsaTransferProviderIntroStep: React.FC<IsaTransferProviderIntroStepProps> = ({
    onBack,
    onContinue
}) => {
    const analytics = useUnifiedAnalytics();

    useEffect(() => {
        if (analytics) {
            analytics.trackAnalyticsPageEvent(
                'provider intro view',
                {},
                'ISA Transfer Provider Intro',
                'ISA_Transfer_Provider_Intro|Page_Load|Intro_View'
            );
        }
    }, [analytics]);

    const handleBack = () => {
        if (analytics) {
            analytics.trackAnalyticsClickEvent(
                'back',
                '',
                'isa transfer provider intro',
                'ISA Transfer',
                '',
                {},
                'click',
                'ISA_Transfer_Provider_Intro|Button_Click|Back',
                'ISA Transfer Provider Intro'
            );
        }
        onBack();
    };

    const handleContinue = () => {
        if (analytics) {
            analytics.trackAnalyticsClickEvent(
                'start your transfer',
                '',
                'isa transfer provider intro',
                'ISA Transfer',
                '',
                {},
                'click',
                'ISA_Transfer_Provider_Intro|Button_Click|Start_Your_Transfer',
                'ISA Transfer Provider Intro'
            );
        }
        onContinue();
    };

    return (
        <main className="isa-transfer-provider-intro">
            <h1>Before you start your transfer</h1>

            <div className="isa-transfer-provider-intro__content">
                <div className="isa-transfer-provider-intro__section">
                    <p className="isa-transfer-provider-intro__subtitle">You&apos;ll need:</p>

                    <div className="isa-transfer-provider-intro__list-item">
                        <svg className="isa-transfer-provider-intro__tick" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 9.5L6.5 14L14 5" stroke="#30384A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Your current Cash ISA account number</span>
                    </div>

                    <div className="isa-transfer-provider-intro__list-item">
                        <svg className="isa-transfer-provider-intro__tick" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 9.5L6.5 14L14 5" stroke="#30384A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>The amount you want to transfer</span>
                    </div>

                    <div className="isa-transfer-provider-intro__list-item">
                        <svg className="isa-transfer-provider-intro__tick" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 9.5L6.5 14L14 5" stroke="#30384A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Up-to-date personal details</span>
                    </div>
                </div>

                <p className="isa-transfer-provider-intro__info">
                    If your name, address, email, phone number or National Insurance number don&apos;t
                    match those held by your current ISA provider, your transfer could be rejected.
                </p>

                <div className="isa-transfer-provider-intro__profile-link">
                    <span>Need to update your details?</span>
                    <a href="/my-profile" className="isa-transfer-provider-intro__link">
                        Go to My Profile
                    </a>
                </div>

                <p className="isa-transfer-provider-intro__footnote">
                    You can only have one cash ISA transfer in progress at a time. You&apos;ll need
                    to wait until your current transfer is complete before starting another.
                </p>
            </div>

            <div className="isa-transfer-provider-intro__actions">
                <IdsButton appearance="default" size="md" onClick={handleBack}>
                    Back
                </IdsButton>
                <IdsButton appearance="primary" size="md" onClick={handleContinue}>
                    Start your transfer
                </IdsButton>
            </div>
        </main>
    );
};

export default IsaTransferProviderIntroStep;